"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Themes;

(function (Themes) {
  Themes["INHERIT"] = "";
  Themes["DEFAULT"] = "lsg--theme__light";
  Themes["LIGHT"] = "lsg--theme__light";
  Themes["DARK"] = "lsg--theme__dark";
  Themes["GREY"] = "lsg--theme__grey";
  Themes["GRAY"] = "lsg--theme__grey";
})(Themes = exports.Themes || (exports.Themes = {}));